<template>
  <section class="datatable__container">
    <transition name="fade" mode="out-in">
      <dr-loader size="lg" v-if="!loaded"  class="flex-center" />

      <template v-if="getRows.length > 0">
        <datatable
          ref="table"
          :columns="columns"
          class="datatable__table"
          :page="currentPage"
          :per-page="100"
          :filter-by="filterBy"
          :data.sync="getRows"
          :buttons="['copy', 'csv', 'excel', 'pdf', 'print']"
        >
          <template slot-scope="{ row }">
            <tr class="datatable__row">
              <td class="datatable__cell"
                v-for="(rowVal,rowName, $index) in orderRow(row)"
                v-show="rowName !== 'key' && !getProp(columns, rowName, 'hide')"
                :class="getProp(columns, rowName, 'class') + ' ' + ( 'text-' + getProp(columns, rowName, 'align')) || ''"
                :key="'row' + $index"
              >
                <span v-if="getProp(columns, rowName, 'action') === 'label'">
                  <i :class="fn_PROCEDURES_STATUS_CLASS(row.status)" class="label">
                    {{row.status}}
                  </i>
                </span>

                <span v-else-if="getProp(columns, rowName, 'field') === 'value' ">
                  <span class="value">
                    {{row.value}}
                  </span>
                </span>

                <span v-else-if="getProp(columns, rowName, 'field') === 'agendaAppointmentStart' ">
                  <span class="date pointer" @click="editProcedure(row)">
                    {{getFilter(rowName, rowVal)}}
                  </span>
                </span>

                <span v-else>
                  {{getFilter(rowName, rowVal)}}
                </span>
              </td>
            </tr>
          </template>
        </datatable>
      </template>

      <h2 v-if="loaded && getRows.length === 0" class="datatable__no-data">
        Não existem procedimentos agendados.
      </h2>
    </transition>

    <editProcedureModal
      class="modal"
      :active.sync="modalActive"
      :procedure.sync="currentProcedure"
      @cancel="modalActive = null"
      @success="$parent.$emit('success')"
    />
  </section>
</template>

<script>
import editProcedureModal from '@/components/modals/editProcedure'
import { mapGetters } from 'vuex'

export default {
  props: ['columns', 'rows', 'page', 'perPage', 'filterBy', 'row', 'rowData', 'expand'],
  components: {
    editProcedureModal
  },
  data () {
    return {
      modalActive: false,
      localRows: [],
      localRowData: [],
      updateTable: false,
      currentPage: 1,
      getTransition: 'fade',
      getTransition2: 'slide-down',
      loaded: false,
      expanded: null,
      loaded2: false,
      currentProcedure: []
    }
  },
  // mounted () {
  //   this.getRows = this.rows
  //   if (this.rows.length > 0) {
  //     this.loaded = true
  //   }
  // },
  computed: {
    ...mapGetters({
      office: 'getCurrentOffice'
    }),

    getRoute () {
      return this.$route.name
    },
    getPerPage () {
      return this.perPage || 10
    },
    getPage () {
      return this.currentPage
    },
    getCustomer () {
      return this.$store.getters.getParentObj.customerId
    },
    getRowData: {
      get () {
        return this.localRowData
      },
      set (v) {
        this.localRowData = v
      }
    },
    getRows: {
      get () {
        return this.localRows
      },
      set (rows) {
        let key = 0
        this.localRows = []
        for (let row of rows) {
          if (this.fn_IS_OBJ(row)) {
            this.localRows.push(row)
            this.localRows[key].key = key
            key++
          }
        }
        this.loaded = true
      }
    }
  },
  watch: {
    rows: {
      deep: true,
      immediate: true,
      handler (next) {
        this.getRows = next
        this.loaded = true
      }
    },

    rowData (next, prev) {
      const self = this
      self.getRowData = next
      setTimeout(() => {
        self.loaded2 = true
      }, 1500)
    },
    'currentPage': function (next, prev) {
      if (next > prev) {
        this.getTransition = 'fade_left'
      } else {
        this.getTransition = 'fade_right'
      }
    }
  },
  methods: {
    expandRow (id, y, m) {
      const self = this
      self.loaded2 = false
      setTimeout(function () {
        self.getRowData = []
        if (self.expanded !== id) {
          self.$refs.datatable.$parent.$parent.$emit('expand', [y, m])
          self.expanded = id
        } else {
          self.expanded = null
        }
      }, 400)
    },
    appointmentStatus (appointmentField, id) {
      for (let row of this.getRows) {
        if (row.agendaId === id) {
          if (row.status !== 'REALIZADO') {
            if (this.$moment(row.agendaAppointmentStart).format('YYYY-MM-DD') === this.$moment(new Date()).format('YYYY-MM-DD')) {
              if (row.status === 'EM ANDAMENTO') {
                return 1 // em andamento
              } else {
                return 2 // iniciar consulta
              }
            } else {
              return 3 // lupa
            }
          } else {
            return 4 // consulta finalizada
          }
        }
      }
    },
    proceduresStatusLabelClass (status) {
      this.fn_PROCEDURES_STATUS_CLASS(status)
    },
    getFilter (rowName, rowValue) {
      if (this.getProp(this.columns, rowName, 'filter')) {
        return this.$root.$options.filters[this.getProp(this.columns, rowName, 'filter')](rowValue)
      } else {
        return rowValue
      }
    },
    orderRow (row) {
      let obj = {}
      let key = 0
      for (let col of this.columns) {
        obj[col.field] = row[col.field]
        if (this.rowData) {
          obj.key = key++
        }
      }
      return obj
    },
    changePage (v) {
      if ((v < 0 && this.currentPage === 1) || (v > 0 && this.currentPage === Math.floor(this.getRows / this.perPage))) {
        return
      }
      this.currentPage = this.currentPage + v
    },
    updateRows () {
      this.getRows = null
    },
    mutateForm (id) {
      let updateObj = {}
      updateObj.activeId = id
      updateObj['active' + this.customerForm] = this.customerForm + 'Form'
      this.$store.dispatch('reloadDatatables')
      this.$store.dispatch('updateParentObj', updateObj)
    },
    mutateList (id) {
      let updateObj = {}
      updateObj.eventId = id
      updateObj.activeTab = 'stocks'
      this.$store.dispatch('updateParentObj', updateObj)
    },
    deleteRow (row) {
      this.$emit('removeRow', row)
    },
    checkInt (cols, field) {
      for (let col of cols) {
        if (col.field === field) {
          return col.intType
        }
      }
    },
    getProp (cols, field, prop) {
      for (let col of cols) {
        if (col.field === field) {
          return col[prop]
        }
      }
    },
    editProcedure (procedure) {
      this.currentProcedure = procedure
      this.modalActive = true
    }
  }
}
</script>
